import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DataStorageService {


  public storage: Storage;


  public barHeader: string = "";



  public currentLanguage = "en";

  constructor() {
    if (typeof(Storage) !== "undefined") {
      this.storage = window.localStorage;
    }
    else {
      this.storage = null;
    }
    this.currentLanguage = this.getLanguage();
  }

  getLanguage(): string {
    return "fi";
  }



  getStorageItem(key: string): any {
    if (this.storage != null) {
      return this.storage.getItem(key);
    }
    else {
      return null;
    }
  }

  setLanguage(language: string) {
    if (this.storage != null) {
      this.storage.setItem("language", language);
    }
    this.currentLanguage = language;
  }



  setStorageItem(key: string, value: any) {
    if (this.storage != null) {
      this.storage.setItem(key, value);
    }
  }



  removeStorageItem(key: string) {
    if (this.storage != null) {
      this.storage.removeItem(key);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/data-storage.service.ts